import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

//Format page number to double digit
export const formatPage = function (pageNumber) {
  return pageNumber.toString().padStart(2, "0");
};

//Check if number is even
export const isEven = (value) => Number(value) % 2 === 0;

//Generate markup for stack cards
export const generateCards = function (data) {
  return data.stack.map((tech) => {
    return `
  <div class="projects__tech-card">
  <svg class="projects__tech-icon icon--${tech.tech}">
  <use href="#${tech.tech}"></use>
  </svg>
  <h4 class="projects__tech-card-desc hidden">
   ${tech.label}
   </h4>
  </div>
   `;
  });
};

//Generate cards timeline
export const generateCardsTimeline = function (data) {
  //Filter for even pages
  const evenPages = Object.values(data).filter((page) =>
    isEven(page.element.dataset.page),
  );

  gsap.registerPlugin(ScrollTrigger);

  evenPages.forEach((page) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: page.content,
        start: "top top",
        scrub: true,
      },
    });
    const cardsArr = Array.from(page.tech.children);

    moveCards(page.tech, tl).to(cardsArr, {
      skewX: "0%",
      rotate: "0deg",
      width: "6rem",
      height: "6rem",
      onStart: () => {
        //Cards on left at the start
        page.tech.style.justifySelf = "start";

        //Adding desc
        cardsArr.forEach((card) => {
          const desc = card.children[1];
          desc.classList.remove("hidden");
        });
      },

      onComplete: () => {
        page.content.style.height = "min-content";
      },

      onReverseComplete: () => {
        //Cards on center at start
        page.tech.style.justifySelf = "center";

        //Removing desc
        cardsArr.forEach((card) => {
          const desc = card.children[1];
          desc.classList.add("hidden");
        });
      },
    });
    return tl;
  });
};

//Two steps transition between cards
export const moveCards = function (tech, tl) {
  Array.from(tech.children).forEach((card, i) => {
    tl.to(card, {
      skewX: "45deg",
      translateY: `-${i * 80}%`,
      opacity: 1,
    });
  });

  return tl;
};
